import { h, FunctionComponent } from 'preact';
import { Link } from 'preact-router/match';
import { TournamentSummary } from '../../../services/slot-tournaments';
import { Trans } from '@lingui/macro';

interface VictoryVaultTournamentCardProps {
    tournament: TournamentSummary;
}

const VictoryVaultTournamentCard: FunctionComponent<VictoryVaultTournamentCardProps> = ({ tournament }) => {
    // TODO: Implement "You Joined" logic
    const isJoined = true;
    const icon = {
        'default': require('url:../assets/img/toto-promo/victory-vault.svg'),
        'bonus': require('url:../assets/img/toto-promo/victory-vault-bonus.png'),
    };
    const iconType = tournament.title.includes('BONUS') ? 'bonus' : 'default';

    return (
        <div class="shrink-0 w-64 rounded-lg shadow-lg bg-harif-950 text-white overflow-hidden mx-2">
            <div class="p-4">
                <h3 class="text-center font-bold text-white text-lg mb-2">{tournament.title}</h3>
                <div class="flex justify-center items-center my-4">
                    <img src={icon[iconType]} alt="Victory Vault Logo" class="w-24 h-24 drop-shadow rounded-lg" />
                </div>
                <div class="text-center text-xs text-white mb-4">
                    <p><Trans>Starts</Trans>: {new Date(tournament.start_date).toLocaleDateString()}</p>
                    <p><Trans>Ends</Trans>: {new Date(tournament.end_date).toLocaleDateString()}</p>
                </div>
                <div class="flex flex-col space-y-2">
                    <a href={`/slot-tournaments/${tournament.id}`} class="w-full text-center py-2 px-4 bg-gray-200 text-gray-800 font-semibold rounded-md hover:bg-gray-300 transition-colors">
                        <Trans>Read More</Trans>
                    </a>
                    {isJoined && (
                        <button disabled class="w-full text-center py-2 px-4 bg-gray-400 text-white font-semibold rounded-md cursor-not-allowed">
                            <Trans>You Joined</Trans>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VictoryVaultTournamentCard;